import { render } from "./NewBusinessModal.vue?vue&type=template&id=2ae5e9e3&scoped=true"
import script from "./NewBusinessModal.vue?vue&type=script&lang=js"
export * from "./NewBusinessModal.vue?vue&type=script&lang=js"

import "./NewBusinessModal.vue?vue&type=style&index=0&id=2ae5e9e3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ae5e9e3"]])

export default __exports__